<template>
    <el-table :data="list" size="mini" border :default-sort = "{prop: 'number', order: 'ascending'}">
        <el-table-column align="center" label="马号" prop="number">
        </el-table-column>
        <el-table-column label="马匹名称" prop="name">
        </el-table-column>
        <el-table-column label="烙号" prop="brand">
        </el-table-column>
        <el-table-column label="练马师" prop="trainerName">
        </el-table-column>
        <el-table-column label="骑师" prop="jockeyName">
        </el-table-column>
    </el-table>
</template>

<script>
    export default{
        name: "HorseList",
        props: {
            list: Array
        }
    }
</script>

<style scoped>

</style>